import { PROFILE_TRADING_CONFIG_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetPfofileTradingConfigByProfileCode(code) {
    const api = `${PROFILE_TRADING_CONFIG_API}profiles/${code}/`;
    return axiosHttp.get(api);
}